import { render, staticRenderFns } from "./IntegrationPageHeader.vue?vue&type=template&id=00ba2752&"
import script from "./IntegrationPageHeader.vue?vue&type=script&lang=js&"
export * from "./IntegrationPageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports